import { jsx } from "react/jsx-runtime";
import { memo, useId } from "react";
import { PhoneInput } from "./PhoneInput/PhoneInput.js";
import { ControlBody } from "../common/ControlBody.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
const PhoneInputControl = memo(
  ({
    sx,
    uncontrolled,
    onChange,
    value,
    label,
    error,
    tip,
    optional,
    name,
    className,
    disabled,
    hideTipText,
    onBlur,
    compact = !0,
    size = "md",
    ignoreLabelHeight,
    ignoreHintHeight,
    defaultCountry = "US",
    autoComplete,
    errorViewType,
    ...restProps
  }) => {
    const id = useId();
    return /* @__PURE__ */ jsx(
      ControlBody,
      {
        sx,
        label,
        error,
        errorViewType,
        tip,
        optional,
        className,
        disabled,
        hideTipText,
        compact,
        size,
        ignoreLabelHeight,
        ignoreHintHeight,
        "data-test-id": restProps["data-test-id"],
        children: /* @__PURE__ */ jsx(
          PhoneInput,
          {
            "data-test-id": DATA_TEST_ID_INHERITED,
            size,
            className,
            onChange,
            onBlur,
            disabled,
            name,
            id,
            value: uncontrolled ? void 0 : value,
            defaultCountry,
            error: !!error,
            autoComplete,
            ...restProps
          }
        )
      }
    );
  }
);
PhoneInputControl.displayName = "PhoneInputControl";
export {
  PhoneInputControl
};
//# sourceMappingURL=PhoneInputControl.js.map
